import React from "react";
import { PostHogProvider } from "posthog-js/react";

/**
 * This is the highest place in the React tree we can place components.
 * It is a good place to put a context provider.
 */
export default function RootWrapper({ element }) {
  return (
    <PostHogProvider
      apiKey={process.env.POSTHOG_API_KEY}
      options={{
        api_host: "https://us.i.posthog.com",
        person_profiles: "identified_only",
      }}
    >
      {element}
    </PostHogProvider>
  );
}
